import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { UserSelector } from "/app/src/model";
import Login from "./Login";
import Dashboard from "./Dashboard";

class App extends Component {
  render() {
    if (this.props.loggedIn) return <Dashboard />;
    return <Login />;
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: UserSelector.isLoggedIn(state),
  };
}

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// src/layout/index.js